import React from 'react';
import { cn } from '@/utils/cn';

function NavigationTitle({ children, className = '', ...rest }) {
  return (
    <h4
      className={cn(
        'navigation-title text-[18px] text-coarse-wool font-encode-sans font-semibold leading-28 tracking-[0.36px] capitalize',
        className,
      )}
      {...rest}
    >
      {children}
    </h4>
  );
}

export default NavigationTitle;
